const routes = [
  {
    path: '/carAccessRecord', // 人员通行授权
    name: 'carAccessRecord',
    component: () => import('./pages/Home'),
    redirect: '/carAccessRecord/index',
    meta: {
      requireAuth: false
    },
    children: [
      {
        path: 'index', // 
        name: 'carAccessRecordIndex',
        component: () => import('./pages/index'),
        meta: {
          requireAuth: false,
          routerAlive: true
        }
      },
    ]
  }
]

export default routes